// extracted by mini-css-extract-plugin
var _1 = "XIxbD7mqQV7V8hkQI4p7";
var _2 = "XIxbD7mqQV7V8hkQI4p7";
var _3 = "OczwdDxQfBLInwJQ8BN9";
var _4 = "OczwdDxQfBLInwJQ8BN9";
var _5 = "e_iV_JLV8TgOeRsNwtqd";
var _6 = "e_iV_JLV8TgOeRsNwtqd";
export { _1 as "add-work-button", _2 as "addWorkButton", _3 as "form-bottom-margin", _4 as "formBottomMargin", _5 as "no-bottom-padding", _6 as "noBottomPadding" }
